// extracted by mini-css-extract-plugin
export var buttonIcon = "RecipeSelect-module--buttonIcon--vbKb5";
export var buttonText = "RecipeSelect-module--buttonText--DwUay";
export var container = "RecipeSelect-module--container--DZAEY";
export var content = "RecipeSelect-module--content--katK9";
export var footer = "RecipeSelect-module--footer--7T4Jt";
export var header = "RecipeSelect-module--header--yU0sw";
export var noProducts = "RecipeSelect-module--noProducts--C3DOP";
export var qtyButton = "RecipeSelect-module--qtyButton--DRqBV";